<template>
    <div class="tab-content-container">
        <div class="tab-header-container">
            <h2 class="form-label">Лични данни</h2>
            <LiteButton @click.native="editButtonClicked"
                        class="edit-button"
                        v-show="!shouldEditOverallInfo"
                        :hoverColor="'blue'"
                        :icon="'far fa-edit'">
            </LiteButton>
            <LiteButton @click.native="editButtonClicked"
                        style="font-size: 27px;"
                        class="edit-button"
                        v-show="shouldEditOverallInfo"
                        :hoverColor="'red'"
                        :icon="'far fa-window-close'">
            </LiteButton>

            <div class="last-modified-container">
                <p class="last-modified-date" v-text="getPersonalInfoLastModifiedDate"></p>
                <p class="last-modified-name" v-text="getPersonalInfoLastModifiedBy"></p>
            </div>
        </div>

        <hr class="form-line">

        <!--    when preview    -->

        <!--     personal info       -->
        <div class="text-container" v-if="!shouldEditOverallInfo">
            <div class="form-column-container">
                <TextField class="text-field"
                           :label="'Име'"
                           :value="personalInfo.firstName">
                </TextField>

                <TextField class="text-field"
                           :label="'Презиме'"
                           :value="personalInfo.middleName">
                </TextField>

                <TextField class="text-field"
                           :label="'Фамилия'"
                           :value="personalInfo.lastName">
                </TextField>

                <TextField class="text-field"
                           :label="'Имена на латиница'"
                           :value="latinNames">
                </TextField>

                <TextField class="text-field"
                           :label="'ЕГН'"
                           :value="personalInfo.egn">
                </TextField>

            </div>
            <div class="form-column-container">
                <TextField class="text-field"
                           :label="'Гражданство'"
                           :value="personalInfo.country ? personalInfo.country.name : ''">
                </TextField>

                <TextField class="text-field"
                           :label="'Адрес'"
                           :value="personalInfo.address">
                </TextField>

                <TextField class="text-field"
                           :label="'Телефон'"
                           :value="personalInfo.phoneNumber">
                </TextField>

                <TextField class="text-field"
                           :label="'Е-Мейл'"
                           :value="personalInfo.email">
                </TextField>

                <TextField class="text-field"
                           :label="'Център'"
                           :value="personalInfo.region ? personalInfo.region.name : ''">
                </TextField>
            </div>
        </div>

        <hr class="form-line" v-if="!shouldEditOverallInfo"/>

        <div class="text-container" v-if="!shouldEditOverallInfo">
            <div class="form-column-container" style="width: 70%">
                <TextField class="text-field"
                           :label="'Пол'"
                           :value="getGender">
                </TextField>

                <TextField class="text-field"
                           :label="'Разрешение за превоз с микробус'"
                           :value="personalInfo.busPermission ? 'Да' : 'Не'">
                </TextField>

                <TextField class="text-field"
                           :label="'Семейно положение'"
                           :value="personalInfo.familyStatus">
                </TextField>

                <TextField class="text-field"
                           :label="'Номер на дрехи'"
                           :value="personalInfo.clothesSize ? personalInfo.clothesSize + '' : ''">
                </TextField>

                <TextField class="text-field"
                           :label="'Номер на обувки'"
                           :value="personalInfo.shoesSize ? personalInfo.shoesSize + '' : ''">
                </TextField>
            </div>
            <div class="form-column-container" style="width: 30%">
            </div>
        </div>

        <!--    when edit    -->
        <form class="form-container" v-if="shouldEditOverallInfo">
            <div class="form-column-container">
                <InputText class="input"
                           @value-change="setAttribute"
                           :id="'firstName'"
                           :name="'firstName'"
                           :label="'Име'"
                           :initialValue="workerPersonalInfo.firstName"
                           :placeholder="'Въведете име'"
                           :showError="shouldShowError('firstName')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('firstName')" :text="errors['firstName']"/>

                <InputText class="input"
                           @value-change="setAttribute"
                           :id="'middleName'"
                           :name="'middleName'"
                           :label="'Презиме'"
                           :initialValue="workerPersonalInfo.middleName"
                           :placeholder="'Въведете презиме'"
                           :showError="shouldShowError('middleName')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('middleName')" :text="errors['middleName']"/>

                <InputText class="input"
                           @value-change="setAttribute"
                           :id="'lastName'"
                           :name="'lastName'"
                           :label="'Фамилия'"
                           :initialValue="workerPersonalInfo.lastName"
                           :placeholder="'Въведете фамилия'"
                           :showError="shouldShowError('lastName')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('lastName')" :text="errors['lastName']"/>

                <InputText class="input"
                           @value-change="setAttribute"
                           :id="'latinFirstName'"
                           :name="'latinFirstName'"
                           :label="'Име на латински'"
                           :initialValue="workerPersonalInfo.latinFirstName"
                           :placeholder="'Въведете име на латиница'"
                           :showError="shouldShowError('latinFirstName')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('latinFirstName')" :text="errors['latinFirstName']"/>

                <InputText class="input"
                           @value-change="setAttribute"
                           :id="'latinMiddleName'"
                           :name="'latinMiddleName'"
                           :label="'Презиме на латински'"
                           :initialValue="workerPersonalInfo.latinMiddleName"
                           :placeholder="'Въведете презиме на латиница'"
                           :showError="shouldShowError('latinMiddleName')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('latinMiddleName')" :text="errors['latinMiddleName']"/>

                <InputText class="input"
                           @value-change="setAttribute"
                           :id="'latinLastName'"
                           :name="'latinLastName'"
                           :label="'Фамилия на латински'"
                           :initialValue="workerPersonalInfo.latinLastName"
                           :placeholder="'Въведете фамилия на латиница'"
                           :showError="shouldShowError('latinLastName')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('latinLastName')" :text="errors['latinLastName']"/>

                <InputText class="input"
                           @value-change="setAttribute"
                           :id="'egn'"
                           :name="'egn'"
                           :label="'ЕГН'"
                           :initialValue="workerPersonalInfo.egn"
                           :placeholder="'Въведете ЕГН'"
                           :showError="shouldShowError('egn')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('egn')" :text="errors['egn']"/>
            </div>
            <div class="form-column-container">
                <SelectDropDown v-if="countries"
                                class="document-add-dropdown"
                                style="margin-bottom: 20px;"
                                :id="'country'"
                                :name="'country'"
                                :options="countries"
                                :defaultSelected="{id: personalInfo.country ? personalInfo.country.iso : ''}"
                                :placeholder="'Изберете държава'"
                                :label="'Държава'"
                                @selection-change="setAttribute"
                />

                <InputText class="input"
                           @value-change="setAttribute"
                           :id="'address'"
                           :name="'address'"
                           :label="'Адрес'"
                           :initialValue="workerPersonalInfo.address"
                           :placeholder="'Въведете адрес'"
                           :showError="shouldShowError('address')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('address')" :text="errors['address']"/>

                <InputText class="input"
                           @value-change="setAttribute"
                           :id="'phoneNumber'"
                           :name="'phoneNumber'"
                           :label="'Телефон'"
                           :initialValue="workerPersonalInfo.phoneNumber"
                           :placeholder="'Въведете телефон'"
                           :showError="shouldShowError('phoneNumber')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('phoneNumber')" :text="errors['phoneNumber']"/>

                <InputText class="input"
                           @value-change="setAttribute"
                           :id="'email'"
                           :name="'email'"
                           :label="'Е-Мейл'"
                           :initialValue="workerPersonalInfo.email"
                           :placeholder="'Въведете Е-Мейл'"
                           :showError="shouldShowError('email')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('email')" :text="errors['email']"/>

                <SelectDropDown class="input"
                                @selection-change="setAttribute"
                                :id="'region'"
                                :name="'region'"
                                :label="'Център'"
                                :options="getRegions"
                                :defaultSelected="workerPersonalInfo.region ? workerPersonalInfo.region : {id: null}"
                                :placeholder="'Изберете Център'">
                </SelectDropDown>
                <ErrorInput class="error" v-if="shouldShowError('email')" :text="errors['email']"/>
            </div>

            <hr class="form-line"/>

            <div class="form-container" v-if="shouldEditOverallInfo">
                <div class="form-column-container">
                    <SelectDropDown class="input"
                                    @selection-change="setGender"
                                    :id="'gender'"
                                    :name="'gender'"
                                    :label="'Пол'"
                                    :options="getGenderOptions"
                                    :defaultSelected="{id: workerPersonalInfo.gender}"
                                    :placeholder="'Изберете пол'">
                    </SelectDropDown>
                    <ErrorInput class="error" v-if="shouldShowError('email')" :text="errors['email']"/>

                    <Checkbox class="input"
                              @value-change="setBusPermission"
                              :id="'busPermission'"
                              :label="'Разрешение за превоз с микробус'"
                              :initialValue="workerPersonalInfo.busPermission"/>

                    <InputText class="input"
                               @value-change="setAttribute"
                               :id="'familyStatus'"
                               :name="'familyStatus'"
                               :label="'Семейно положение'"
                               :initialValue="workerPersonalInfo.familyStatus"
                               :placeholder="'Въведете семейно положение'"
                               :showError="shouldShowError('familyStatus')">
                    </InputText>
                    <ErrorInput class="error" v-if="shouldShowError('familyStatus')" :text="errors['familyStatus']"/>

                    <InputText class="input"
                               @value-change="setAttribute"
                               :id="'clothesSize'"
                               :name="'clothesSize'"
                               :label="'Номер на дрехите'"
                               :isNumber="true"
                               :initialValueNumber="workerPersonalInfo.clothesSize"
                               :placeholder="'Въведете номер на дрехи'"
                               :showError="shouldShowError('clothesSize')">
                    </InputText>
                    <ErrorInput class="error" v-if="shouldShowError('clothesSize')" :text="errors['clothesSize']"/>

                    <InputText class="input"
                               @value-change="setAttribute"
                               :id="'shoesSize'"
                               :name="'shoesSize'"
                               :label="'Номер на обувки'"
                               :isNumber="true"
                               :initialValueNumber="workerPersonalInfo.shoesSize"
                               :placeholder="'Въведете номер на обувки'"
                               :showError="shouldShowError('shoesSize')">
                    </InputText>
                    <ErrorInput class="error" v-if="shouldShowError('shoesSize')" :text="errors['shoesSize']"/>
                </div>
                <div class="form-column-container">
                </div>


                <Button class="save-button"
                        @click.native="savePersonalInfo"
                        :color="'green'"
                        :text="'Запази'"
                        :icon="'fa fa-save'"></Button>
            </div>
        </form>

        <hr class="form-line"/>

        <WorkerEducationsForm/>

        <hr class="form-line" style="margin-top: 40px;"/>

        <WorkerLanguagesForm/>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import InputText from "@/shared/components/form/InputText";
    import ErrorInput from "@/shared/components/form/ErrorInput";
    import Button from "@/shared/components/button/Button";
    import LiteButton from "@/shared/components/button/LiteButton";
    import TextField from "@/shared/components/TextField";
    import workerService from "@/services/worker.service";
    import mapperService from "@/services/mapper.service";
    import {cloneDeep} from 'lodash';
    import SelectDropDown from "@/shared/components/form/SelectDropDown";
    import WorkerEducationsForm from "@/components/worker/form/WorkerEducationsForm";
    import WorkerLanguagesForm from "@/components/worker/form/WorkerLanguagesForm";
    import sharedService from "@/services/shared.service";
    import Checkbox from "@/shared/components/form/Checkbox";

    export default {
        name: "WorkerPersonalInfo",
        components: {
            Checkbox,
            WorkerLanguagesForm,
            WorkerEducationsForm, SelectDropDown, TextField, LiteButton, InputText, ErrorInput, Button
        },
        created() {
            this.regionsCache = cloneDeep(this.allRegions);

            sharedService.fetchCountries()
                .then(({data}) => {
                    data.forEach((country) => country.id = country.iso);
                    this.countries = data
                });
        },
        data() {
            return {
                shouldEditOverallInfo: false,
                workerPersonalInfo: cloneDeep(this.personalInfo),
                errors: {},
                countries: null,
                regionsCache: cloneDeep(this.allRegions)
            }
        },
        methods: {
            setAttribute(value) {
                this.workerPersonalInfo[value.name] = value.currentValue;
                this.errors[value.name] = null;
            },
            setGender(value) {
                if (value.currentValue && value.currentValue.id) {
                    this.workerPersonalInfo.gender = value.currentValue.id;
                }
            },
            setBusPermission(value) {
                this.workerPersonalInfo.busPermission = value.isChecked;
            },
            shouldShowError(fieldName) {
                return !!(this.errors && this.errors[fieldName]);
            },
            editButtonClicked() {
                this.shouldEditOverallInfo = !this.shouldEditOverallInfo;
                this.workerPersonalInfo = cloneDeep(this.personalInfo);
            },
            savePersonalInfo() {
                workerService.updatePersonalInfo(this.workerPersonalInfo)
                    .then(({data}) => {
                        this.$store.commit('setPersonalInfo', data);
                        this.shouldEditOverallInfo = false;
                    })
                    .catch(() => alert("Грешка, моля опитайте отново!"));
            }
        },
        computed: {
            ...mapGetters(['personalInfo', 'allRegions']),

            getPersonalInfoLastModifiedBy() {
                return mapperService.getLastModifiedBy(this.personalInfo);
            },
            getPersonalInfoLastModifiedDate() {
                return mapperService.getLastModifiedDate(this.personalInfo);
            },
            getRegions() {
                if (Array.isArray(this.regionsCache)) {
                    return this.regionsCache;
                }
                return [];
            },
            latinNames() {
                if (this.workerPersonalInfo) {
                    const firstName = this.workerPersonalInfo.latinFirstName ? this.workerPersonalInfo.latinFirstName : '';
                    const middleName = this.workerPersonalInfo.latinMiddleName ? this.workerPersonalInfo.latinMiddleName : '';
                    const lastName = this.workerPersonalInfo.latinLastName ? this.workerPersonalInfo.latinLastName : '';
                    return firstName + ' ' + middleName + ' ' + lastName;
                }
                return '';
            },
            getGender() {
                if (this.personalInfo.gender) {
                    if (this.personalInfo.gender === 'MALE') {
                        return 'Мъж';
                    } else {
                        return 'Жена';
                    }
                }
                return '';
            },
            getGenderOptions() {
                return [
                    {
                        id: 'MALE',
                        name: 'Мъж'
                    },
                    {
                        id: 'FEMALE',
                        name: 'Жена'
                    }
                ]
            }
        },
        watch: {
            personalInfo: {
                handler(newVal) {
                    if (newVal) {
                        this.workerPersonalInfo = cloneDeep(newVal);
                    }
                },
                deep: true
            },
            allRegions: {
                handler(newVal) {
                    if (newVal) {
                        this.regionsCache = cloneDeep(newVal);
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .form-container {
        width: 100%;
        height: fit-content;
    }

    .form-column-container {
        width: 50%;
        padding: 20px 100px;
        margin: 0 auto;
        display: inline-grid;
        height: fit-content;
        box-sizing: border-box;
    }

    .input {
        height: 95px;
        margin: 20px auto 0 auto;
    }

    @media only screen and (max-width: 1350px) {
      .form-column-container {
        padding: 20px;
      }
    }
</style>
